import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        licence: '='
    },
    template: `
    <div class="well color03">
        <div class="heading01">
            <h2>{{ 'licence.Licence periods' | translate }}</h2>
            <a class="btn add" ng-click="vm.add(vm.licence)">{{ 'licence.Add period' | translate }}</a>
        </div>
        <div class="tablewrapper">
            <list-empty list="vm.periods" show-add-message="true"></list-empty>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.periods.length">
                <thead>
                <tr>
                    <th>{{ 'licence.Points per period' | translate }}</th>
                    <th>{{ 'licence.Acquiring deadline' | translate }}</th>
                    <th>{{ 'licence.Entering deadline' | translate }}</th>
                    <th>&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="item in vm.periods">
                    <td>{{ item.pointsPerPeriod }}</td>
                    <td>{{ item.acquiringDate | date : 'dd.MM.yyyy' }}</td>
                    <td>{{ item.enteringDate | date : 'dd.MM.yyyy' }}</td>
                    <td class="actions">
                        <a ng-if="vm.isEditable(item.acquiringDate)" class="btn edit" ng-click="vm.edit(item)">{{ 'licence.Edit' | translate }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    `
})
export default class {
    constructor (DATATABLES, MomentService, ModalService, LicencePeriodResource, LicenceResource) {
        this.DATATABLES = DATATABLES;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
        this.LicencePeriodResource = LicencePeriodResource;
        this.LicenceResource = LicenceResource;
        this.periods = this.licence.licencePeriods;
    }

    edit (period) {
        this.LicencePeriodResource.get({ id: period.id, expand: 'initialLicencePeriod,licencePoints' })
            .$promise.then(response => {
                return this.ModalService.open({
                    size: 'medium',
                    template: `
                    <modals-manage-licences-edit-periods-edit
                        uib-modal-instance="vm.uibModalInstance"
                        licence-period="vm.licencePeriod"
                     />
                `,
                    controller ($uibModalInstance) {
                        this.uibModalInstance = $uibModalInstance;
                        this.licencePeriod = response;
                    }
                }).then(() => {
                    this.reloadLicence();
                });
            });
    }

    add (licence) {
        return this.ModalService.open({
            size: 'medium',
            template: `
                <modals-manage-licences-edit-periods-add
                    uib-modal-instance="vm.uibModalInstance"
                    licence="vm.licence"
                 />
            `,
            controller ($uibModalInstance) {
                this.uibModalInstance = $uibModalInstance;
                this.licence = licence;
            }
        }).then(() => {
            this.reloadLicence();
        });
    }

    reloadLicence () {
        this.LicenceResource.get({ id: this.licence.id, expand: 'licencePeriods,licenceDrlsWithValue,licencePoints,licencePreconditions' })
            .$promise.then((reloadedLicence) => {
                this.licence = reloadedLicence;
                this.periods = this.licence.licencePeriods;
            });
    }

    isEditable (acquiringDate) {
        return !this.MomentService.isPassedDate(acquiringDate) && !this.MomentService.isCurrentDate(acquiringDate);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/settings/licences/periods/index.js